import { Component, Mixins } from 'vue-property-decorator';
import applicationStore from '@/store/modules/applications/applicationStore';
import AccountSettings from '@/mixins/accountSettings.mixin';
import Tooltip from '@/mixins/tooltip.mixin';
import APP_CONST from '@/constants/AppConst';

import DashboardNavIcon from './DashboardNavIcon.vue';
import catalogIcon from '@/components/icons/catalog-icon.vue';
import homeIcon from '@/components/icons/home-icon.vue';

@Component({
  components: {
    DashboardNavIcon,
    catalogIcon,
    homeIcon,
  }
})
export default class DashboardLeftPanel extends Mixins(AccountSettings, Tooltip) {
  public readonly APP_ROUTES = APP_CONST.APP_ROUTES;
  APP_CONST = APP_CONST;

  /* istanbul ignore next */
  get scholarsList() {
    return applicationStore.submittedScholars;
  }

  /* istanbul ignore next */
  get selectedScholar() {
    return applicationStore.selectedScholar;
  }

  public visitRoute(route: string) {
    /* istanbul ignore else */
    if (this.$route && this.$route.path !== route) {
      this.$router.push(route);
    }
  }

  mounted() {
    if (this.$route && this.$route.path != APP_CONST.APP_ROUTES.DASHBOARD.path) {
      applicationStore.getScholarsInfoByGuardian();
    }
  }

  public showScholarDetails(guid: string) {
    localStorage.removeItem('selectedGuid');
    /* istanbul ignore next */
    applicationStore.getScholarData(guid).then(() => {
      applicationStore.mutateEditFormMode(false);
      applicationStore.mutateEditProgramFormMode(false);
      applicationStore.mutateDeletedForAuthorize([]);
    });

    applicationStore.mutateDocumentArray([]);
    applicationStore.mutateScholarDocument({});
    /* istanbul ignore else */
    if (this.$route && this.$route.path !== '/scholar/details') {
      this.$router.push('/scholar/details');
    }
  }
}